import customHeaders, { getSpace } from '../../../common/headers';
import { useState, useEffect, useRef } from 'react';
import {
  DropDownSelector,
  ButtonBasic,
  InputDinamycPlaceholder,
  CheckboxToggle,
  CheckboxToggleBlue,
  TableBox,
  ButtonClose
} from '@lk-gtcom/ecomlab-components';
import usePushStore from '../../../store/toast';
import { DynamicFormComponent } from '../../../components/DynamicFormComponent/DynamicFormComponent';
import { FilterContainer } from '../../../components/FilterContainer/FilterContainer';
import { TabsGreyBtn } from '../../../components/TabsGreyBtn/TabsGreyBtn';
import { useDataTable } from '../../../common/hooks';
import { StepItem } from '../../../components/StepItem/StepItem';
import { fetchApiFilterVer3 } from '../../../common/filtersFunc';
import { fetchPaymentTypeFilter } from '../../../common/filtersFunc';
import { TitlePage } from '../../../components/TitlePage/TitlePage';
import useGeneralStore from '../../../store/general';
import './ModalCreateCampaignFromRules.scss';
import { TextPage } from '../../../components/TextPage/TextPage';
import { options_prop_mp } from '../../../common/globalVariables';
import { StepPoints } from '../../../components/StepPoints/StepPoints';
import { ModalHistoryActions } from './ModalHistoryActions/ModalHistoryActions';
import { SingleDatePicker } from '../../../components/SingleDatePicker/SingleDatePicker';
import { ModalСonfirmation } from './ModalСonfirmation/ModalСonfirmation'
import { usePushNotifications } from '../../../common/pushNotification';
import { TimeGridSelector } from '../../../components/TimeGridSelector/TimeGridSelector';
import { useResponseHandler } from '../../../common/auth';

const btn_tab = [
  {
    label: 'Добавленные',
    value: 'active',
  },
  {
    label: 'Можно добавить',
    value: 'inactive'
  }
]

const btn_tab_2 = [
  {
    label: 'Участвуют',
    value: 'participate',
  },
  {
    label: 'Не участвуют',
    value: 'not_participate',
  }
]

const transformOptions = (opinion_param) => {
  const result = {};

  opinion_param.forEach(item => {
    const opinionId = item.opinion_id.toString(); // ключ - строка
    if (!result[opinionId]) {
      result[opinionId] = [];
    }
    result[opinionId].push({
      id: item.param_id,
      name: item.param_name
    });
  });

  return result;
}

const ModalCreateCampaignFromRules = ({
  setIsModal,
  currentСampaign,
  setCurrentСampaign
}) => {

  const addPush = usePushStore((state) => state.addPush);
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };

  // Рефы
  const fileInputRef = useRef(null);

  // Обработка ошибок
  const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();

  const [apiData, setApiData] = useState([]);
  const [paymentTypeData, setPaymentTypeData] = useState([])
  const [strategiesList, setStrategiesList] = useState([]);

  const current_strat_param = currentСampaign?.strat_param?.map(({ param_id, param_name, type, filter_link, value, is_array, possible_values }) => ({
    id: param_id,
    attribute_name: param_name,
    data_type: type,
    filter_link,
    value,
    is_array,
    possible_values
  }))

  useEffect(() => {
    setParamsList(current_strat_param)
  }, [currentСampaign?.strat_param]);

  const [paramsList, setParamsList] = useState(current_strat_param)
  const [optionList, setOptionList] = useState(currentСampaign ? currentСampaign?.strat_param : [])

  const [selectedMarketplace, setSelectedMarketplace] = useState(currentСampaign?.mp_id ?
    options_prop_mp.filter(({ value }) => value == currentСampaign?.mp_id)?.[0] : options_prop_mp[0]);
  const [selectedApi, setSelectedApi] = useState(currentСampaign ? currentСampaign?.api_id : []);
  const [selectedPaymentType, setSelectedPaymentType] = useState(currentСampaign ? currentСampaign?.payment_type : []); ///
  const [selectedStrategies, setSelectedStrategies] = useState(currentСampaign ? {
    label: currentСampaign?.strat_attr?.name,
    value: currentСampaign?.strat_attr?.id,
    description: currentСampaign?.strat_attr?.description
  } : [])

  const [apiPage, setApiPage] = useState(1);
  const [apiQuery, setApiQuery] = useState('');

  const [paymentTypePage, setPaymentTypePage] = useState(1);
  const [paymentTypeQuery, setPaymentTypeQuery] = useState('');
  const [title, setTitle] = useState(currentСampaign?.name || '');

  const [isCheck, setIsCheck] = useState(currentСampaign ? currentСampaign?.active : false);
  const [isCheckTimeOption, setIsCheckTimeOption] = useState(false)

  const [paramsValues, setParamsValues] = useState(currentСampaign ? currentСampaign?.strat_param : [])



  const [optionValues, setOptionValues] = useState(currentСampaign?.opinion_param?.length ? currentСampaign?.opinion_param : [])
  const [isCheckOptions, setIsCheckOptions] = useState(currentСampaign?.option_id_list?.length ? currentСampaign?.option_id_list : [])
  const [isDeleteArrayOption, setIsDeleteArrayOption] = useState([])
  const [paramsListOptions, setParamsListOptions] = useState(currentСampaign?.opinion_param?.length ? transformOptions(currentСampaign?.opinion_param) : {})
  const [currentStep, setCurrentStep] = useState(1)

  // Таблица
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
  const { total, loading } = tableProps;
  const [tableUrl, setTableUrl] = useState('');
  const [tableBody, setTableBody] = useState(null);
  const [selectedItems, setSelectedItems] = useState([])
  const refContainer = useRef()
  const [loadingUpload, setLoadingUpload] = useState(false)

  // Табы 
  const [currentTab, setCurrentTab] = useState(btn_tab[0].value)
  const [currentTab2, setCurrentTab2] = useState(btn_tab_2[0].value)

  // Логи
  const [logCount, setLogCount] = useState(0)

  const filters_data = {
    7: {
      brand: 4,
      category: 10
    },
    18: {
      brand: 19,
      category: 20
    },
    19: {
      brand: 16,
      category: 17
    },
    28: {
      brand: 41,
      category: 42
    },
    29: {
      brand: 44,
      category: 45
    }
  }

  // Фильтры для определенных стратегий
  const SPECIAL_STRATEGIES = [7, 18, 19, 28, 29];
  const strategyValue = selectedStrategies?.value;
  const cur_id_brand = filters_data[strategyValue]?.brand
  const cur_id_category = filters_data[strategyValue]?.category
  const curr_brand = currentСampaign?.strat_param_filter?.find(({ param_id }) => param_id === cur_id_brand);
  const curr_category = currentСampaign?.strat_param_filter?.find(({ param_id }) => param_id === cur_id_category);
  const curr_period_budget = currentСampaign?.strat_param_filter?.find(({ param_id }) => param_id === 50);

  const default_category = curr_category ? curr_category?.label_value : [{ label: 'Все', value: 'all' }]
  const default_brand = curr_brand ? curr_brand?.label_value : [{ label: 'Все', value: 'all' }]
  const defaul_period_budget = curr_period_budget ? curr_period_budget?.label_value?.[0] : { label: 'Все', value: 'all' }

  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState(default_category);
  const [selectedBrand, setSelectedBrand] = useState(default_brand);
  const [selectedPeriodBudget, setSelectedPeriodBudget] = useState(defaul_period_budget);

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0);
  const [totalPeriodBudget, setTotalPeriodBudget,] = useState(0)

  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [selectedFile, setSelectedFile] = useState(false)
  const [isModalConfirmation, setIsModalConfirmation] = useState(false)

  // Период
  const [selectedRange, setSelectedRange] = useState([])

  // Modal 
  const [isModalLog, setIsModalLog] = useState(false)

  const categoryFilter = () => {
    fetchApiFilterVer3({
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalCategory,
      page: categoryPage,
      apiData,
      selectedApi,
      selectedCategory,
      set: setCategoryData,
      setCategoryData: (e) => setCategoryData(e),
      searchParam: categoryQuery,
      filter: 'category',
      setTotal: setTotalCategory
    });
  };

  useEffect(() => {
    categoryFilter();
  }, [categoryPage, categoryQuery]);

  const brandFilter = () => {
    fetchApiFilterVer3({
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalBrand,
      apiData,
      categoryData,
      selectedApi,
      selectedCategory,
      page: brandPage,
      searchParam: brandQuery,
      set: setBrandData,
      setBrandData: (e) => setBrandData(e),
      filter: 'brand',
      setTotal: setTotalBrand
    });
  };

  useEffect(() => {
    brandFilter();
  }, [brandPage, brandQuery]);

  const filters = (<FilterContainer
    onReset={
      (e) => {
        setSelectedCategory([])
        setSelectedBrand([])
      }
    }
  >
    < DropDownSelector
      options_prop={categoryData}
      state={selectedCategory}
      total={totalCategory}
      setState={(e) => {
        setSelectedCategory(e)
        if (SPECIAL_STRATEGIES.includes(strategyValue)) {
          setParamsValues(prev => {
            const paramIndex = prev?.findIndex(item => item?.param_id === cur_id_category);
            if (paramIndex !== -1) {
              return prev?.map((item, index) =>
                index === paramIndex ? { ...item, value: e?.map(({ value }) => value) || '' } : item
              );
            }
            return [...prev, { param_id: cur_id_category, value: e?.map(({ value }) => value) || '' }];
          });
        }
      }}
      placeholder="Категория"
      fetchCallback={setCategoryPage}
      setInputChange={setCategoryQuery}
      multi
      onBlur={() => {
        brandFilter();
        fetchTableData()
      }}
    />

    < DropDownSelector
      options_prop={brandData}
      state={selectedBrand}
      total={totalBrand}
      setState={(e) => {
        setSelectedBrand(e)
        if (SPECIAL_STRATEGIES.includes(strategyValue)) {
          setParamsValues(prev => {
            const paramIndex = prev?.findIndex(item => item?.param_id === cur_id_brand);
            if (paramIndex !== -1) {
              return prev?.map((item, index) =>
                index === paramIndex ? { ...item, value: e?.map(({ value }) => value) } : item
              );
            }
            return [...prev, { param_id: cur_id_brand, value: e?.map(({ value }) => value) }];
          });
        }
      }}
      placeholder="Бренд"
      fetchCallback={setBrandPage}
      setInputChange={setBrandQuery}
      multi
      onBlur={() => {
        fetchTableData()
      }}
    />
  </FilterContainer >)

  // Создание кампании
  const fetchСreateСampaign = () => {
    setLoading(true);
    let url = `https://apps1.ecomru.ru:4450/api/v1/campaign/create`

    const body = JSON.stringify({
      active: isCheck,
      name: title,
      api_id: selectedApi?.value,
      payment_type: selectedPaymentType?.value,
      strat_id: selectedStrategies?.value,
      mp_id: selectedMarketplace?.value,
      strat_params: paramsValues,
      option_id_list: isCheckOptions,
      option_params: optionValues
    })

    fetch(url, { body, method: 'POST', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          addErrorPush('Не удалось создать кампанию')
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        addSuccessPush('Кампания успешно создана')
        setCurrentСampaign(json)
        setCurrentStep(2)
        setTimeout(() => {
          fetchGetLogCount()
        }, 500)
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 1000);
      });
  };

  // Редактирование кампании
  const fetchChangeСampaign = () => {
    setLoading(true);
    let url = `https://apps1.ecomru.ru:4450/api/v1/campaign/change`

    const body = JSON.stringify({
      id: currentСampaign?.uid,
      active: isCheck,
      name: title,
      strat_id: selectedStrategies?.value,
      strat_params: paramsList.map(({ id, value, data_type }) => (
        {
          param_id: id,
          value: data_type === 'filter' ? value?.map((el => el?.value)) : value
        }
      )),
      option_id_list: isCheckOptions,
      option_params: optionValues
    })

    fetch(url, { body, method: 'PUT', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          addErrorPush('Не удалось редактировать кампанию')
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        addSuccessPush('Изменения в кампании успешно сохранены')
      })
      .catch((err) => {
        console.error(err);
        setTimeout(() => fetchGetLogCount(), 500)
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 1000);
      });
  };

  // Получение стратегий
  const fetchGetStrategies = () => {
    let url = `https://apps1.ecomru.ru:4450/api/v1/strategies/list`

    const body = JSON.stringify({
      api_id: selectedApi?.value,
      mp_id: selectedMarketplace?.value
    });

    fetch(url, { method: 'POST', headers, body })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        const current_option = json.map(({ id, name, description }) => {
          return {
            label: `${name} (${description})`,
            value: id
          }
        })
        setStrategiesList(current_option)
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // Получение параметров стратегий
  const fetchGetParams = () => {
    // setParamsList([])
    // const strategies = [1, 2, 4, 6, 7, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
    // if (!strategies.includes(selectedStrategies?.value)) return
    let url = `https://apps1.ecomru.ru:4450/api/v1/strategies/parameters?strat_id=${selectedStrategies?.value}`

    fetch(url, { method: 'GET', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        const current = json?.map(({ param_id, param_name, type, filter_link, value, is_array }) => ({
          id: param_id,
          attribute_name: param_name,
          data_type: type,
          filter_link,
          value,
          is_array
        }))
        // setParamsList(current)
        if (!currentСampaign?.strat_param) {
          setParamsValues(current)
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const [params33, setParams33] = useState([])

  // шаг 3 для 33 стратагии
  const fetchGetParams33 = () => {

    let url = `https://apps1.ecomru.ru:4450/api/v1/get_category_budget?uid=${currentСampaign?.uid}`

    fetch(url, { method: 'GET', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        setParams33(json?.category_budgets)
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // шаг 3 сохранение 33 стратагии
  const fetchSetParams33 = () => {

    let url = `https://apps1.ecomru.ru:4450/api/v1/set_category_budget`

    const body = JSON.stringify({
      uid: currentСampaign?.uid,
      category_budgets: params33
    })

    fetch(url, { method: 'POST', headers, body })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        addSuccessPush('Бюджеты категорий успешно сохранены');
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (selectedStrategies?.value == 33) {
      fetchGetParams33()
    }
  }, []);

  // Получение параметров стратегии 4, 13
  const fetchTableData = (params, abortController = new AbortController()) => {
    const strategies = [4, 13]
    if (!strategies.includes(selectedStrategies?.value)) return

    let sort;
    let filters;

    if (params) {
      [sort, filters] = params;
    }

    const orderParam = sort?.[0] ?
      `?order_param=${sort?.[0]}&order_param_direction=${sort?.[1]}`
      :
      ''

    let url = `https://apps1.ecomru.ru:4450/api/v1/strat_4/products/${currentTab}${orderParam}`

    let category_id_list, brand_id_list

    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory.map((el) => el.value);
    } else {
      category_id_list = ['all'];
    }

    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand.map((el) => el.value);
    } else {
      brand_id_list = ['all'];
    }

    const body = JSON.stringify({
      brand_id_list,
      category_id_list,
      api_id: selectedApi?.value,
      filters,
      limit: paginatorRef.current?.limit || 10,
      page: paginatorRef.current?.page || 1,
      client_strat_uid: currentСampaign?.uid
    });

    fetch(url, {
      body,
      method: 'POST',
      headers,
      signal: abortController.signal,
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        setTable(json);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoading(false);
      });
  };

  // Получение таблицы параметров [3, 15, 16]
  const fetchTableDataDRR = (params, abortController = new AbortController()) => {
    const strategies = [2, 3, 12, 15, 16]
    if (!strategies.includes(selectedStrategies?.value)) return
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    setLoading(true);

    let url = `https://apps1.ecomru.ru:4450/api/v1/drr/table/${currentTab2}${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''
      }`

    let api_id_list = selectedApi?.value ? [selectedApi?.value] : []
    let brand_id_list;
    let category_id_list;

    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand?.map((el) => el.value);
    }

    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }

    const body = JSON.stringify({
      category_id_list,
      brand_id_list,
      api_id_list,
      limit: paginatorRef.current?.limit || 10,
      page: paginatorRef.current?.page || 1,
      filters: filtersParam,
      strat_uid: currentСampaign?.uid
    })

    fetch(url, {
      body,
      method: 'POST',
      headers,
      signal: abortController.signal,
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        setTable(json);
        setTableUrl(url);
        setTableBody(body);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      });
  };

  // Получение таблицы параметров [31]
  const fetchTableData31 = (params, abortController = new AbortController()) => {
    let stock = paramsList.filter((el) => el?.id === 51)?.[0]?.value

    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    setLoading(true);

    let url = `https://apps1.ecomru.ru:4450/api/v1/strat_stock/products?stock=${stock}${sort?.length > 0
      ? '&order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''
      }`

    let curr_list_brand = paramsList.filter((el) => el?.attribute_name === 'Брэнд')?.[0]?.value
    let curr_list_category = paramsList.filter((el) => el?.attribute_name === 'Категория')?.[0]?.value

    let api_id = selectedApi?.value
    let brand_id_list = curr_list_brand?.map((el) => el?.value) || []
    let category_id_list = curr_list_category?.map((el) => el?.value) || []


    const body = JSON.stringify({
      category_id_list,
      brand_id_list,
      api_id,
      limit: paginatorRef.current?.limit || 10,
      page: paginatorRef.current?.page || 1,
      filters: filtersParam,
    })

    fetch(url, {
      body,
      method: 'POST',
      headers,
      signal: abortController.signal,
    })
      .then(handleTableResponse)
      .then((json) => {
        setTable(json);
      })
      .catch(handleRequestError)
      .finally(() => {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      });
  };

  // Изменения списка товаров для стратегии №4 
  const fetchSetProductList = (action, all = false) => {
    let url = `https://apps1.ecomru.ru:4450/api/v1/strat_4/change/${action}`

    const offer_id_list = selectedItems.map(el => el?.['Товар']?.[4])

    const body = JSON.stringify({
      api_id: selectedApi?.value,
      offer_id_list: all ? ['all'] : offer_id_list,
      client_strat_uid: currentСampaign?.uid
    });

    fetch(url, { method: 'POST', headers, body })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        console.log(json)
        setTimeout(() => fetchGetLogCount(), 500)
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // Загрузить шаблон стратегия 5
  const onUploadFile = (file, status) => {
    if (!file) {
      return;
    }

    setLoadingUpload(true)
    addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')
    const url = `https://apps1.ecomru.ru:4450/api/v1/set_drr/${currentСampaign?.uid}/update_from_excel?action=${status ? 'replace' : 'add'}`;

    const formData = new FormData();
    formData.append('file', file);

    const updatedHeaders = { ...headers };
    delete updatedHeaders['Content-Type'];

    fetch(url, {
      method: 'POST',
      updatedHeaders,
      headers: updatedHeaders,
      body: formData,
    })
      .then(async (res) => {
        const data = await res.json(); // сначала парсим ответ
        if (!res.ok) {
          const errorMessage = data.detail;
          addErrorPush(`Ошибка загрузки: ${errorMessage}`);
          throw new Error(`Upload failed: ${res.statusText}`);
        }
        return res.json();
      })
      .then((data) => {
        addSuccessPush('Файл успешно загружен')
        if (fileInputRef.current) fileInputRef.current.value = ''
        setTimeout(() => fetchTableDataDRR(), 1000)
      })
      .catch((err) => {
        console.error(err);
        if (fileInputRef.current) fileInputRef.current.value = ''
      })
      .finally(() => {
        setLoadingUpload(false)
        setSelectedFile(null)
      });
  };

  const handleCheck = (data) => {
    setSelectedItems(data)
  }

  useEffect(() => {
    if ([31].includes(selectedStrategies?.value) && paramsList?.length) {
      const abortController = new AbortController();
      fetchTableData31([], abortController);
      return () => abortController.abort();
    }
  }, [selectedStrategies?.value]);

  useEffect(() => {
    if ([4, 13].includes(selectedStrategies?.value)) {
      const abortController = new AbortController();
      fetchTableData([], abortController);
      return () => abortController.abort();
    }
    if ([2, 3, 12, 15, 16].includes(selectedStrategies?.value)) {
      const abortController = new AbortController();
      fetchTableDataDRR([], abortController)
      return () => abortController.abort();
    }
  }, [
    selectedStrategies,
    currentTab,
    currentTab2,
    selectedBrand,
    selectedCategory
  ]);

  // Получение опций
  const fetchGeOption = () => {
    let url = `https://apps1.ecomru.ru:4450/api/v1/opinion/list`

    const body = JSON.stringify({
      api_id: selectedApi?.value,
      mp_id: selectedMarketplace?.value,
      strat_id: selectedStrategies?.value
    });

    fetch(url, { method: 'POST', headers, body })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        setOptionList(json)
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // Получение параметров опций
  const fetchGetOptionParam = (id) => {
    let url = `https://apps1.ecomru.ru:4450/api/v1/opinion/parameters?opinion_id=${id}`

    fetch(url, { method: 'GET', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        setParamsListOptions((prev => {
          return { ...prev, [id]: json }
        }))
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // Каунтер логов
  const fetchGetLogCount = () => {
    if (!currentСampaign?.uid) return
    let url = `https://apps1.ecomru.ru:4450/api/v1/strategies/counter?uid=${currentСampaign?.uid}`

    fetch(url, { method: 'GET', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        setLogCount(json?.logs || 0)
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    fetchGetLogCount()
  }, []);

  const fetchDeleteOption = (id) => {
    let url = `https://apps1.ecomru.ru:4450/api/v1/opinion/delete`

    const body = JSON.stringify({
      uid: currentСampaign?.uid,
      opinion_id_list: isDeleteArrayOption
    });

    fetch(url, { method: 'DELETE', headers, body })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        console.log(json)
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // Установить период
  const fetchSetRange = (id) => {
    let url = `https://apps1.ecomru.ru:4450/api/v1/set_schedule?action=replace`

    const body = JSON.stringify({
      uid: currentСampaign?.uid,
      schedule_dict: selectedRange
    })

    fetch(url, { method: 'POST', headers, body })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        addSuccessPush('Период успешно сохранен')
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // Получить период
  const fetchGetRange = (id) => {
    let url = `https://apps1.ecomru.ru:4450/api/v1/get_schedule?uid=${currentСampaign?.uid}`

    fetch(url, { method: 'GET', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        if (json) {
          setSelectedRange(json)
          if (json?.length) {
            setIsCheckTimeOption(true)
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const onCloseModal = () => {
    setIsModal(false)
    setCurrentСampaign(null)
  }

  useEffect(() => {
    fetchGetParams()
    fetchGeOption()
    fetchGetRange()
  }, [selectedStrategies]);

  useEffect(() => {
    fetchGetStrategies()
  }, [selectedMarketplace, selectedApi]);

  const apiFilter = () => {
    fetchApiFilterVer3({
      selectedSpace: selectedSpace?.value,
      page: apiPage,
      setApiData: setApiData,
      set: setApiData,
      searchParam: apiQuery,
      selectedApi,
      selectedShop: selectedMarketplace,
      filter: 'api_id',
    });
  };

  const paymentTypeFilter = () => {
    fetchPaymentTypeFilter({
      selectedSpace: selectedSpace?.value,
      page: paymentTypePage,
      set: setPaymentTypeData,
      searchParam: paymentTypeQuery,
      selectedShop: selectedMarketplace,
    });
  };

  useEffect(() => {
    paymentTypeFilter();
  }, [paymentTypePage, paymentTypeQuery]);

  // Установка дрр
  const fetchSetDrr = (
    offerId,
    newPrice,
    setStatus
  ) => {
    let url = `https://apps1.ecomru.ru:4450/api/v1/set_drr`

    const body = JSON.stringify({
      price: [{
        offer_id: offerId,
        target_drr: newPrice,
        client_strat_uid: currentСampaign?.uid
      }]
    })

    fetch(url, { body, method: 'POST', headers })
      .then((res) => {
        if (res.ok) {
          setStatus('success');
          return res.json();
        } else {
          throw Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        fetchTableDataDRR([]);
      })
      .catch((err) => {
        setStatus('error');
        console.error(err);
      });
  };

  useEffect(() => {
    apiFilter();
  }, [apiPage, apiQuery]);

  const isDisabled = !selectedMarketplace?.value || !selectedApi?.value || !title || !selectedStrategies?.value || !selectedPaymentType?.value

  useEffect(() => {
    if (!selectedStrategies?.value || !title) {
      setCurrentStep(1)
    }
  }, [selectedStrategies, title]);

  useEffect(() => {
    if (currentСampaign) {
      setCurrentStep(2)
    }
  }, [currentСampaign]);

  // Открытие чекбоксов опций, при первом рендере
  useEffect(() => {
    isCheckOptions.forEach((id) => {
      fetchGetOptionParam(id)
    })
  }, []);

  const handleSetDrr = async (e) => {
    const { inputEvent, actionEvent, setStatus } = e;
    const offerId = actionEvent?.[0]?.offer_id;
    const productId = actionEvent?.[0]?.product_id;
    const colName = actionEvent?.[2];
    let newPrice;

    newPrice = +inputEvent?.value;

    if (newPrice) {
      setStatus('loading');
      fetchSetDrr(offerId, newPrice, setStatus);
    } else {
      setStatus('error');
    }
  };

  const handleFileChange = async (e) => {
    setIsModalConfirmation(true)
    setSelectedFile(e.target.files[0])
  };

  return (
    <>
      {isModalLog && <ModalHistoryActions
        setIsModal={setIsModalLog}
        uid={currentСampaign?.uid}
      />}

      {
        isModalConfirmation && <ModalСonfirmation
          setIsModal={setIsModalConfirmation}
          onUploadFile={onUploadFile}
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
        />}

      <div
        className="blackout blackout-modal"
        onClick={(e) => {
          let el = e.target;
          if (el.classList.contains('blackout-modal')) {
            onCloseModal()
          }
        }}
      >
        <div className="modal-create-campaign-from-rules">
          <div className="modal-create-campaign-from-rules__header">
            <TitlePage
              title={currentСampaign
                ? `Редактирование кампании`
                : `Добавление новой кампании`}
            />

            <label className="modal-create-campaign-from-rules__label">
              <CheckboxToggle
                text='Активно'
                value={isCheck}
                onChange={(e) => setIsCheck(!isCheck)}
              />
            </label>

            <ButtonClose
              onClick={(e) => {
                onCloseModal()
              }}
            />
          </div>

          <div className="modal-create-campaign-from-rules__main-content">
            <div className="modal-create-campaign-from-rules__left-content">
              <TitlePage
                medium
                title='Общие параметры'
              />

              <InputDinamycPlaceholder
                position="left"
                maxWidth="100%"
                isOpen={true}
                onChange={(value) => setTitle(value)}
                changeValue={title}
                placeholder="Введите название кампании"
                size="s"
                required={true}
              />

              <div className="modal-create-campaign-from-rules__select-group">
                <DropDownSelector
                  required={true}
                  state={selectedMarketplace}
                  options_prop={options_prop_mp}
                  total={options_prop_mp?.length}
                  setState={(e) => setSelectedMarketplace(e)}
                  placeholder="Площадка"
                  onBlur={() => {
                    setSelectedPaymentType(null)
                    apiFilter()
                    paymentTypeFilter()
                  }}
                  disabled={currentСampaign}
                />

                <DropDownSelector
                  state={selectedApi}
                  options_prop={apiData}
                  total={totalApi}
                  setState={setSelectedApi}
                  placeholder="Магазин"
                  fetchCallback={setApiPage}
                  setInputChange={setApiQuery}
                  required={true}
                  disabled={currentСampaign}
                />
              </div>

              <div className="modal-create-campaign-from-rules__select-group">
                <DropDownSelector
                  state={selectedPaymentType}
                  options_prop={paymentTypeData}
                  setState={(e) => setSelectedPaymentType(e)}
                  placeholder="Тип оплаты"
                  fetchCallback={(e) => setPaymentTypePage(e)}
                  setInputChange={(e) => setPaymentTypeQuery(e)}
                  required={true}
                  disabled={currentСampaign}
                />
              </div>

              <TitlePage
                medium
                title='Выбор стратегии'
              />

              <DropDownSelector
                state={selectedStrategies}
                options_prop={strategiesList}
                setState={(e) => setSelectedStrategies(e)}
                placeholder="Стратегия"
                required={true}
                disabled={currentСampaign}
              />

              <ButtonBasic
                green
                text="Сохранить"
                size='56px'
                onClick={(e) => {
                  if (currentСampaign) {
                    fetchChangeСampaign()
                  } else {
                    fetchСreateСampaign()
                  }
                  fetchSetRange()
                  categoryFilter()
                  brandFilter()
                  // fetchDeleteOption(isDeleteArrayOption)
                }}
                style={{ marginTop: 'auto' }}
                disabled={isDisabled}
              />
            </div>

            <div className="modal-create-campaign-from-rules__right-content">
              {currentСampaign && <ButtonBasic
                blue
                onClick={(e) => setIsModalLog(true)}
                text={`Посмотреть историю - ${logCount}`}
                style={{ marginLeft: 'auto', minHeight: '40px' }}
                size='40px'
                disabled={!logCount}
              />}

              <div className='modal-create-campaign-from-rules__toolbar'>
                <StepPoints
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  totalSteps={selectedStrategies?.value === 33 ? 4 : 3}
                />

                {currentStep !== 4 && <ButtonBasic
                  green
                  text="Следующий шаг"
                  onClick={(e) => {
                    if (currentStep === 1) {
                      setCurrentStep(2)
                    }
                    if (currentStep === 2) {
                      if (currentСampaign?.strat_attr) {
                        fetchChangeСampaign()
                      }
                      if(selectedStrategies?.value == 33) {
                        setTimeout(() => fetchGetParams33(), 500)
                      }
                      setCurrentStep(3)
                    }
                    if (currentStep === 3 && (selectedStrategies?.value == 33)) {
                      fetchSetParams33()
                      setCurrentStep(4)
                    }
                  }}
                  disabled={isDisabled || !currentСampaign}
                />}
              </div>


              {(currentStep === 1) && <StepItem
                title='Шаг 1: Выбери стратегию '
                description={
                  <>
                    Заполните все обязательные поля, которые находятся ниже и
                    нажмите на кнопку “Следующий шаг”.
                    <span style={{ color: 'red' }}>
                      {' '}
                      Красными звездочками
                    </span>{' '}
                    выделены обязательные пункты для заполнения</>}
              />}

              {(currentStep === 2) && (
                <>
                  <StepItem
                    title='Шаг 2: Выберите параметры стратегии'
                  />

                  <div
                    ref={refContainer}
                    className="prepared_scenarios__content">
                    <TitlePage
                      medium
                      title='Параметры'
                    />

                    {paramsList?.length ?
                      <DynamicFormComponent
                        productTemporary={paramsList}
                        setProductTemporary={setParamsList}
                        api_id={selectedApi?.value}
                        isOpenUp={true}
                      />
                      :
                      <TextPage
                        text='Нет доступных параметров'
                      />}

                    {[31].includes(selectedStrategies?.value) &&
                      <>
                        <ButtonBasic
                          blue
                          width='auto'
                          text='Сохранить параметры и обновить таблицу'
                          onClick={() => {
                            fetchChangeСampaign()
                            fetchTableData31()
                          }}
                        />

                        <TableBox
                          refContainer={refContainer}
                          ref={paginatorRef}
                          paginator={true}
                          {...tableProps}
                          fetchCallback={fetchTableData31}
                        />
                      </>
                    }

                    {/* Для стратегии 4 таблица */}
                    {[4, 13, 3, 15, 16, 2, 12].includes(selectedStrategies?.value)
                      &&
                      <>
                        {filters}

                        {[4, 13].includes(selectedStrategies?.value) &&
                          <TabsGreyBtn
                            btns={btn_tab}
                            currentBtn={currentTab}
                            setCurrentBtn={(e) => setCurrentTab(e)}
                            checkValue={true}
                          />}

                        {[2, 3, 12, 15, 16].includes(selectedStrategies?.value) &&
                          <TabsGreyBtn
                            btns={btn_tab_2}
                            currentBtn={currentTab2}
                            setCurrentBtn={(e) => setCurrentTab2(e)}
                            checkValue={true}
                          />}

                        {[4, 13].includes(selectedStrategies?.value) &&
                          <TableBox
                            refContainer={refContainer}
                            ref={paginatorRef}
                            paginator={true}
                            {...tableProps}
                            fetchCallback={fetchTableData}
                            onCheck={e => handleCheck(e)}
                            onUncheckAllDependence={[currentTab]}
                            child={<>
                              {currentTab == 'active' &&
                                <>
                                  <ButtonBasic
                                    red
                                    text='Удалить выбранные'
                                    size='32px'
                                    disabled={!selectedItems?.length}
                                    onClick={(e) => {
                                      fetchSetProductList('delete')
                                      setTimeout(() => fetchTableData(), 500)
                                    }}
                                  />

                                  <ButtonBasic
                                    red
                                    text='Удалить все'
                                    size='32px'
                                    onClick={(e) => {
                                      fetchSetProductList('delete', true)
                                      setTimeout(() => fetchTableData(), 500)
                                    }}
                                  />
                                </>
                              }

                              {currentTab == 'inactive' &&
                                <>
                                  <ButtonBasic
                                    green
                                    text='Добавить выбранные'
                                    size='32px'
                                    disabled={!selectedItems?.length}
                                    onClick={(e) => {
                                      fetchSetProductList('add')
                                      setTimeout(() => fetchTableData(), 500)
                                    }}
                                  />

                                  <ButtonBasic
                                    green
                                    text='Добавить все'
                                    size='32px'
                                    onClick={(e) => {
                                      fetchSetProductList('add', true)
                                      setTimeout(() => fetchTableData(), 500)
                                    }}
                                  />
                                </>
                              }
                            </>}
                          />}


                        {[2, 3, 12, 15, 16].includes(selectedStrategies?.value) &&
                          <TableBox
                            refContainer={refContainer}
                            ref={paginatorRef}
                            paginator={true}
                            {...tableProps}
                            fetchCallback={fetchTableDataDRR}
                            onCheck={e => handleCheck(e)}
                            onUncheckAllDependence={[currentTab]}
                            onInputAction={(e) => handleSetDrr(e)}
                            child={<>
                              <ButtonBasic
                                blue
                                text='Шаблон загрузки Excel'
                                size='32px'
                                onClick={() => {
                                  const link = document.createElement('a');
                                  link.href = 'https://file.ecomru.ru:4453/api/v1/file/download/3320aee8-3975-4a00-a5bf-0586f88cf88e';
                                  link.download = 'template.xlsx'; // Имя файла
                                  link.style.display = 'none'; // Скрываем ссылку
                                  document.body.appendChild(link);
                                  link.click();
                                }}
                              />


                              <div className='prepared_scenarios__btn-upload'>
                                <ButtonBasic
                                  green
                                  text='Загрузить'
                                  size='32px'
                                  loading={loadingUpload}
                                />

                                <input
                                  type="file"
                                  id="fileInput"
                                  onChange={handleFileChange}
                                  ref={fileInputRef}
                                />
                              </div>
                            </>
                            }
                          />
                        }
                      </>
                    }

                    {/* {(selectedStrategies?.value == 12 || selectedStrategies?.value == 2)
                      &&
                      <InstallationDRR
                        refContainer={refContainer}
                        stopRedirect={true}
                        isShowTitle={false}
                        page={false}
                        selectedMpModal={selectedMarketplace}
                        selectedApiModal={selectedApi}
                      />
                    } */}
                  </div>

                </>
              )}

              {(((currentStep === 3) && selectedStrategies?.value == 33)) &&
                <div className="prepared_scenarios__content">
                  <StepItem
                    title={`Шаг 3: Определите бюджет для категорий`}
                    description={<>
                    Бюджеты, которые не указаны, будут выставлены автоматически. Для сохранения значений.
                    <br/>
                    Для сохранения значений перейдите на следующий шаг
                    </> }
                  />

                  <TitlePage
                    medium
                    title='Заполните поля'
                  />

                  <DynamicFormComponent
                    productTemporary={params33}
                    setProductTemporary={setParams33}
                  />

                </div>}

              {(((currentStep === 3) && selectedStrategies?.value != 33) || ((selectedStrategies?.value == 33) && currentStep === 4)) &&
                <div className="prepared_scenarios__content">
                  <StepItem
                    title={`Шаг ${selectedStrategies?.value == 33 ? 4 : 3}: Выберите опции для стратегии`}
                  />

                  <TitlePage
                    medium
                    title='Опции'
                  />
                  <label className='prepared_scenarios__label'>
                    <CheckboxToggleBlue
                      value={isCheckTimeOption}
                      onChange={(e) => {
                        setIsCheckTimeOption(!isCheckTimeOption)
                        if (isCheckTimeOption) {
                          setSelectedRange([])
                        }
                      }}
                    />

                    <TextPage
                      text={'Часы работы компании'}
                      style={{ fontSize: '14px' }}
                    />
                  </label>

                  {isCheckTimeOption &&

                    <TimeGridSelector
                      selectedRange={selectedRange}
                      setSelectedRange={setSelectedRange}
                      interval={60}
                    />


                  }

                  {
                    optionList?.map(({ name, id, description, value }) => {

                      return <div className='modal-create-campaign-from-rules__row'>
                        <label className='prepared_scenarios__label'>
                          <CheckboxToggleBlue
                            key={id}
                            value={isCheckOptions.includes(id)}
                            onChange={(e) => {
                              if (isCheckOptions.includes(id)) {
                                setIsCheckOptions(isCheckOptions.filter((item) => item !== id));
                                setIsDeleteArrayOption([...isDeleteArrayOption, id])
                              } else {
                                fetchGetOptionParam(id)
                                setIsCheckOptions([...isCheckOptions, id]);
                                setIsDeleteArrayOption(isDeleteArrayOption.filter((item) => item !== id));
                              }
                            }}
                          />
                          <>
                            <TextPage
                              text={name}
                              style={{ fontSize: '14px' }}
                            />
                            <TextPage
                              text={`( ${description} )`}
                              style={{ color: '#475569' }}
                            />
                          </>
                        </label>

                        {isCheckOptions.includes(id) &&

                          paramsListOptions?.[id]?.map(({ id, name, type }) => {
                            if (type == 'period') {
                              const value = optionValues?.find(item => item.param_id === id)?.value
                              return <TimeGridSelector
                                selectedRange={[]}
                                setSelectedRange={(e) => {
                                  const newValue = e
                                  setOptionValues(prev => {
                                    // Ищем параметр в массиве
                                    const paramIndex = prev?.findIndex(item => item?.param_id === id);
                                    // Если параметр найден — обновляем его
                                    if (paramIndex !== -1) {
                                      return prev?.map((item, index) =>
                                        index === paramIndex ? { ...item, value: newValue } : item
                                      );
                                    }
                                    // Если параметра нет — добавляем новый
                                    return [...prev, { param_id: id, value: newValue }];
                                  });
                                }}
                                interval={60}
                              />
                            } else if (type == 'date') {
                              const value = optionValues?.find(item => item.param_id === id)?.value
                              return <SingleDatePicker
                                date={value ? new Date(value) : new Date()}
                                setDate={(e) => {
                                  const newValue = e
                                  setOptionValues(prev => {
                                    // Ищем параметр в массиве
                                    const paramIndex = prev?.findIndex(item => item?.param_id === id);
                                    // Если параметр найден — обновляем его
                                    if (paramIndex !== -1) {
                                      return prev?.map((item, index) =>
                                        index === paramIndex ? { ...item, value: newValue } : item
                                      );
                                    }
                                    // Если параметра нет — добавляем новый
                                    return [...prev, { param_id: id, value: newValue }];
                                  });
                                }}
                                minDate={new Date()}
                              />
                            } else {
                              return <InputDinamycPlaceholder
                                key={id}
                                size='s'
                                placeholder={name}
                                changeValue={optionValues?.find(item => item.param_id === id)?.value || ""}
                                onChange={(e) => {
                                  const newValue = e
                                  setOptionValues(prev => {
                                    // Ищем параметр в массиве
                                    const paramIndex = prev?.findIndex(item => item?.param_id === id);
                                    // Если параметр найден — обновляем его
                                    if (paramIndex !== -1) {
                                      return prev?.map((item, index) =>
                                        index === paramIndex ? { ...item, value: newValue } : item
                                      );
                                    }
                                    // Если параметра нет — добавляем новый
                                    return [...prev, { param_id: id, value: newValue }];
                                  });
                                }}
                              />
                            }
                          })}
                      </div>
                    })
                  }
                </div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { ModalCreateCampaignFromRules };
